// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { Browser } from "@lib/browser/Browser";

/**
 * Provides helper methods for interacting with the cookie API.
 */
export class CookieUtility
{
  static async getCookieStoreID(tabID: number): Promise<string>
  {
    const cookieStores = await Browser.cookies.getAllCookieStores();
    const targetCookieStore = cookieStores.find(cookieStore => cookieStore.tabIds.indexOf(tabID) !== -1);

    if (targetCookieStore === undefined)
      throw new Error(`Can not find a cookie store for tab '${tabID}'.`);

    return targetCookieStore.id;
  }
}